import _ from 'lodash'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import VALUES from 'core/data-model/constants/values'
import { isValidAge } from 'core/service/insured/birthdate'
import { UPDATE_BIRTHDATE } from 'quick-quote/insured-information/actions'
import { getAge } from 'quick-quote/insured-information/selectors'
import { selectModelFactor } from 'quick-quote/product-flexi-health/coverage-plan/actions'
import { SELECTED_PRODUCT } from 'quick-quote/product-selection/actions'
import {
  getSelectedDisplayProductCode,
  getSelectedBasicCategory,
  getDisplayProducts,
} from 'quick-quote/product-selection/selectors'

import { selectBasicPlan } from './actions'

/**
 * createProductLifeSaveProFunc
 * @param {ReturnType<import('quick-quote/product-common/coverage-plan/sagas').createProductCommonCoverageFunc>} productCommonCoverageFunc
 */
export function createProductLifeSaveProFunc(productCommonCoverageFunc) {
  const _switchLifeSaveProProductByAge = (products, age) => {
    const { value, unit } = age
    return _.find(products, (product) => isValidAge(value, unit, _.get(product, 'entryAge')))
  }

  const getProductGroupCodes = (productCode) => {
    const _is20P10Group = () => _.includes(VALUES.LIFE_SAVE_PRO_20P10, productCode)
    const _is25P15Group = () => _.includes(VALUES.LIFE_SAVE_PRO_25P15, productCode)

    return _is20P10Group() ? VALUES.LIFE_SAVE_PRO_20P10 : _is25P15Group() ? VALUES.LIFE_SAVE_PRO_25P15 : []
  }

  const switchLifeSaveProProductByBirthDate = function*() {
    const productCategory = yield select(getSelectedBasicCategory)
    if (productCategory != VALUES.LIFE_SAVE_PRO) return

    const age = yield select(getAge)
    const products = yield select(getDisplayProducts)
    const productCode = yield select(getSelectedDisplayProductCode)
    const productGroupCodes = getProductGroupCodes(productCode)

    const lifeSaveProProducts = _.filter(products, (product) => _.includes(productGroupCodes, _.get(product, 'code')))
    const product = _switchLifeSaveProProductByAge(lifeSaveProProducts, age)

    if (product != undefined && productCode != _.get(product, 'code')) {
      yield put(selectBasicPlan(product))
      yield put(selectModelFactor('model-factor_1'))
      yield call(productCommonCoverageFunc.populateAvailableRiders)
    }
  }

  return {
    _switchLifeSaveProProductByAge,
    switchLifeSaveProProductByBirthDate,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { LIFE_SAVE_PRO } = serviceWrapper.products
  yield [takeLatest([UPDATE_BIRTHDATE, SELECTED_PRODUCT], LIFE_SAVE_PRO.switchLifeSaveProProductByBirthDate)]
}

export const sagas = watchers
